<template>
  <div>
    <Header />
    <Sidebar />
    <slot></slot>
    <Footer />
    <ConfirmationModal :show="showExportConfirmationModal" @confirm="confirmationExportCallback" message="Are you sure to export this?"
                       title="Export"
                       @hide="$store.dispatch('triggerShowExportConfirmationModal', false)"></ConfirmationModal>
    <div v-show="excelLoader || pdfLoader" class="blockUI" style="display:none"></div>
    <div v-show="excelLoader || pdfLoader" class="blockUI blockOverlay"
         style="z-index: 1000; border: none; margin: 0px; padding: 0px; width: 100%; height: 100%; top: 0px; left: 0px; background-color: rgb(0, 0, 0); opacity: 0.5; cursor: wait; position: fixed;"></div>
    <div v-show="excelLoader || pdfLoader" class="blockUI blockMsg blockPage"
         style="z-index: 1011; position: fixed; padding: 0px; margin: 0px; width: 30%; top: 40%; left: 35%; text-align: center; color: rgb(255, 255, 255); border: 0px; background-color: transparent; cursor: wait;">
      <div class="d-flex justify-content-center align-items-center"><p class="mr-50 mb-0">Please wait while your request is being processed...</p>
        <div class="spinner-grow spinner-grow-sm text-white" role="status"></div>
      </div>
    </div>
  </div>
</template>

<script>
import Sidebar from "../layout/Sidebar.vue";
import {mapState} from "vuex";

export default {
  components: {
    Sidebar: Sidebar
  },
  computed:{
    ...mapState(['excelLoader','pdfLoader','showExportConfirmationModal']),
  },
};
</script>

